import { type FC } from 'react';

import { Spinner } from 'dibs-elements/exports/Spinner';
import styles from './styles/CartLoading.scss';

type Props = {
    isStaticLoading: boolean;
    isUpdating: boolean;
};

const CartLoading: FC<Props> = ({ isStaticLoading, isUpdating }) => {
    if (isStaticLoading) {
        return (
            <div className={styles.isStatic}>
                <Spinner dark />
            </div>
        );
    } else if (isUpdating) {
        return (
            <div className={`${styles.overlay} ${styles.isUpdate}`}>
                <Spinner dark />
            </div>
        );
    } else {
        return (
            <div className={styles.overlay}>
                <Spinner dark />
            </div>
        );
    }
};

export default CartLoading;
